import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <a href="asimlawassociates.com">Asim Law Associates</a>
    </div>
  );
};

export default Footer;
